import React from "react";
import styles from "./Statistic.module.css";
const Statistic: React.FC<{ title: string; data: string|React.ReactNode }> = ({
  title,
  data,
}) => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.title}>{title} </span>
      <span className={styles.data}>{data}</span>
    </div>
  );
};

export default Statistic;
